export default __webpack_public_path__ + "static/aib_logo-6b6e07ac34c52f3519b0611b8c5ed0ba.png";